import React from 'react'

import Typography, { TypographyProps } from '../Typography'

type OverlineType = Omit<TypographyProps, 'variant'> & {
  size?: 'md'
  type?: 'default'
}

function Overline ({ size = 'md', type, children, ...rest }: OverlineType) {
  if (React.isValidElement(children)) {
    throw new Error(
      'Overline component does not accept React elements as children'
    )
  }

  return (
    <Typography variant={`overline-${size}`} type={type} {...rest}>
      {children}
    </Typography>
  )
}

export default Overline
